/**
 * Format a price for display, with currency symbol.
 * Returns "TBC" for null/undefined prices.
 */
export function formatPrice(price: number | string | null | undefined): string {
  if (price === null || price === undefined) return 'TBC';
  const num = typeof price === 'string' ? parseFloat(price) : price;
  if (isNaN(num)) return 'TBC';
  return `$${num.toFixed(2)}`;
}

/**
 * Format a date string into a human-readable format.
 * e.g. "Saturday 7 February 2026"
 */
export function formatDate(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

/**
 * Format a date string into a shorter format.
 * e.g. "Sat 7 Feb"
 */
export function formatDateShort(dateString: string): string {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  });
}
